import {B1} from "./internal/B1";
import {B2} from "./internal/B2";
import {B3} from "./internal/B3";
import {B5} from "./internal/B5";
import {B6} from "./internal/B6";
import {B7} from "./internal/B7";
import {B18} from "./internal/B18";
import {B9} from "./internal/B9";
import {B10} from "./internal/B10";
import {B4} from "./internal/B4";
import {B11} from "./internal/B11";
import {B12} from "./internal/B12";
import {B13} from "./internal/B13";
import {B14} from "./internal/B14";
import {B15} from "./internal/B15";
import {B16} from "./internal/B16";
import {B17} from "./internal/B17";
import {B20} from "./internal/B20";
import {B21} from "./internal/B21";
import {B22} from "./internal/B22";
import {B24} from "./internal/B24";
import {B25} from "./internal/B25";
import {B26} from "./internal/B26";
import {B27} from "./internal/B27";
import {B28} from "./internal/B28";
import {B29} from "./internal/B29";
import {B30} from "./internal/B30";
import {B31} from "./internal/B31";
import {C1} from "./compare/C1";
import {C2} from "./compare/C2";
import {C3} from "./compare/C3";
import {C4} from "./compare/C4";
import {C5} from "./compare/C5";
import {C6} from "./compare/C6";
import {C7} from "./compare/C7";
import {C8} from "./compare/C8";
import {C9} from "./compare/C9";
import {C10} from "./compare/C10";
import {C11} from "./compare/C11";
import {C12} from "./compare/C12";
import {C13} from "./compare/C13";
import {C15} from "./compare/C15";
import {C19} from "./compare/C19";
import {C20} from "./compare/C20";
import {C21} from "./compare/C21";
import {B40} from "./internal/B40";
import {B38} from "./internal/B38";
import {G1} from "./internal/G1";
import {G2} from "./internal/G2";
import {G6} from "./internal/G6";
import {G7} from "./internal/G7";
import {XS4} from "./internal/XS4";
import {XS5} from "./internal/XS5";
import {OP5} from "./internal/OP5";
import {FL1} from "./internal/FL1";
import {FL5} from "./internal/FL5";
import {COP2} from "./compare/C-OP2";
import SV1 from "./internal/SV1";
import SV2 from "./internal/SV2";
import SV3 from "./internal/SV3";
import SV4 from "./internal/SV4";
import SV5 from "./internal/SV5";
import SV6 from "./internal/SV6";
import SV7 from "./internal/SV7";
import {XY8} from "./internal/XY8";

export const GetMessageCodeList = () => {
    let messages = []
    Object.keys(MessageCodes.Internal).forEach(key => {
        messages.push(MessageCodes.Internal[key])
    })
    Object.keys(MessageCodes.Compare).forEach(key => {
        messages.push(MessageCodes.Compare[key])
    })

    return messages;
}

export const GetMessageCodeText = (key, error_id) => {
    const message = GetMessageCodeList().find(x => x.key === key && x.error_id === error_id)
    return message?.error_id_text || message?.error_id || key || error_id
}

export const MessageCodes = {
    Internal: {
        SRC00: {key: 'B1', key_text: 'FW1', error_id: 'SRC-00', error_id_text: 'SRC-00', Component: B1},
        TSRC001: {key: 'B1', key_text: 'FW1', error_id: 'T-SRC-01', error_id_text: 'FW 01', Component: B1},
        TSRCICS001: {key: 'B1', key_text: 'FW1', error_id: 'T-SRC-ICS-01', error_id_text: 'FW 01 IB', Component: B1},
        ENCR001: {key: 'B2', key_text: 'FW2', error_id: 'ENCR-01', error_id_text: 'FW 02', Component: B2},
        ENCR00: {key: 'B2', key_text: 'FW2', error_id: 'ENCR-00', error_id_text: 'ENCR-00', Component: B2},
        EM001: {key: 'B3', key_text: 'FW3', error_id: 'EM-01', error_id_text: 'FW 03', Component: B3},
        EM000: {key: 'B3', key_text: 'FW3', error_id: 'EM-00', error_id_text: 'EM-00', Component: B3},
        CEC001: {key: 'B4', key_text: 'RT1', error_id: 'CEC-01', error_id_text: 'RT 01', Component: B4},
        CEC002: {key: 'B4', key_text: 'RT1', error_id: 'CEC-02', error_id_text: 'RT 02', Component: B4},
        CES001: {key: 'B5', key_text: 'ST2', error_id: 'T-CES-01', error_id_text: 'ST 01', Component: B5},
        TDSRL001: {key: 'B6', key_text: 'XS1', error_id: 'T-DSRL-01', error_id_text: 'XS 01', Component: B6},
        DSRL002: {key: 'B6', key_text: 'XS1', error_id: 'DSRL-02', error_id_text: 'XS 02', Component: B6},
        DSRL003: {key: 'B6', key_text: 'XS1', error_id: 'DSRL-03', error_id_text: 'XS 03', Component: B6},
        BM001: {key: 'B7', key_text: 'ST3', error_id: 'BM-01', error_id_text: 'ST 02', Component: B7},
        TBM002: {key: 'B7', key_text: 'ST3', error_id: 'T-BM-02', error_id_text: 'ST 03', Component: B7},
        TBM003: {key: 'B7', key_text: 'ST3', error_id: 'T-BM-03', error_id_text: 'ST 04', Component: B7},
        GR001: {key: 'B9', key_text: 'XY1', error_id: 'GR-01', error_id_text: 'XY 01', Component: B9},
        BSXY001: {key: 'B10', key_text: 'XY2', error_id: 'BSXY-01', error_id_text: 'XY 02', Component: B10},
        BSXY14: {key: 'B10', key_text: 'XY2', error_id: 'XY-14', error_id_text: 'XY 14', Component: B10},
        XCL001: {key: 'B11', key_text: 'XY3', error_id: 'XCL-01', error_id_text: 'XCL-01', Component: B11},
        XCL002: {key: 'B11', key_text: 'XY3', error_id: 'T-XCL-02', error_id_text: 'XY 03', Component: B11},
        XCL003: {key: 'B11', key_text: 'XY3', error_id: 'XCL-03', error_id_text: 'XY 04', Component: B11},
        SKW000: {key: 'B12', key_text: 'XY4', error_id: 'SKW-00', error_id_text: 'SKW-00', Component: B12},
        SKWXY14: {key: 'B12', key_text: 'XY4', error_id: 'XY-14', error_id_text: 'XY 14', Component: B12},
        TSKW001: {key: 'B12', key_text: 'XY4', error_id: 'T-SKW-01', error_id_text: 'XY 05', Component: B12},
        TSKW002: {key: 'B12', key_text: 'XY4', error_id: 'T-SKW-02', error_id_text: 'XY 06', Component: B12},
        SKW003: {key: 'B12', key_text: 'XY4', error_id: 'SKW-03', error_id_text: 'XY 07', Component: B12},
        SKW004: {key: 'B12', key_text: 'XY4', error_id: 'SKW-04', error_id_text: 'XY 08', Component: B12},
        SKW005: {key: 'B12', key_text: 'XY4', error_id: 'SKW-05', error_id_text: 'XY 09', Component: B12},
        HYD000: {key: 'B13', key_text: 'FW5', error_id: 'HYD-00', error_id_text: 'FW 04', Component: B13},
        THYD001: {key: 'B13', key_text: 'FW5', error_id: 'T-HYD-01', error_id_text: 'FW 05', Component: B13},
        THYD002: {key: 'B13', key_text: 'FW5', error_id: 'T-HYD-02', error_id_text: 'FW 06', Component: B13},
        LS01: {key: 'B14', key_text: 'XS2', error_id: 'LS-01', error_id_text: 'XS 04', Component: B14},
        XS01: {key: 'B15', key_text: 'XY5', error_id: 'XS-01', error_id_text: 'XY 10', Component: B15},
        BCF01: {key: 'B16', key_text: 'ST4', error_id: 'BCF-01', error_id_text: 'ST 04', Component: B16},
        FCWSEL01: {key: 'B17', key_text: 'OP1', error_id: 'FC-WSEL-01', error_id_text: 'OP 01', Component: B17},
        XSSTR01: {key: 'B18', key_text: 'ST5', error_id: 'XS-STR-01', error_id_text: 'ST 05', Component: B18},
        FLWSEL01: {key: 'B20', key_text: 'OP2', error_id: 'FL-WSEL-01', error_id_text: 'OP 02', Component: B20},
        TMANN01: {key: 'B21', key_text: 'RT2', error_id: 'T-MANN-01', error_id_text: 'RT 03', Component: B21},
        TMANN02: {key: 'B21', key_text: 'RT2', error_id: 'T-MANN-02', error_id_text: 'RT 04', Component: B21},
        RT05: {key: 'B21', key_text: 'RT2', error_id: 'RT-05', error_id_text: 'RT 05', Component: B21},
        FL01_FL03: {key: 'FL1', key_text: 'FL1', error_id: 'FL 03', error_id_text: 'FL 03', Component: FL1},
        FD01: {key: 'B24', key_text: 'FL2', error_id: 'FD-01', error_id_text: 'FL 04', Component: B24},
        FSTR01: {key: 'B29', key_text: 'FL3', error_id: 'FSTR-01', error_id_text: 'FL 05', Component: B29},
        SIC01: {key: 'B38', key_text: 'FL4', error_id: 'SIC-01', error_id_text: 'FL 06', Component: B38},
        FL5_FL7: {key: 'FL5', key_text: 'FL5', error_id: 'FL 07', error_id_text: 'FL 07', Component: FL5},
        ENCRS01: {key: 'B25', key_text: 'FW4', error_id: 'ENCRS-01', error_id_text: 'FW 00a', Component: B25},
        ENCRS02: {key: 'B25', key_text: 'FW4', error_id: 'ENCRS-02', error_id_text: 'FW 00b', Component: B25},
        TXS01: {key: 'B26', key_text: 'XS3', error_id: 'T-XS-01', error_id_text: 'XS 05', Component: B26},
        XS02: {key: 'B26', key_text: 'XS3', error_id: 'XS-02', error_id_text: 'XS 05a', Component: B26},
        XS03: {key: 'B26', key_text: 'XS3', error_id: 'XS-03', error_id_text: 'XS 05b', Component: B26},
        XS04: {key: 'B26', key_text: 'XS3', error_id: 'XS-04', error_id_text: 'XS 05c', Component: B26},
        XS05: {key: 'B26', key_text: 'XS3', error_id: 'XS-05', error_id_text: 'XS 05d', Component: B26},
        CXWSEL01: {key: 'B27', key_text: 'OP3', error_id: 'CXWSEL-01', error_id_text: 'OP 03', Component: B27},
        CWSEL01: {key: 'B28', key_text: 'OP4', error_id: 'CWSEL-01', error_id_text: 'OP 04', Component: B28},
        SOF01: {key: 'B30', key_text: 'ST6', error_id: 'SOF-01', error_id_text: 'ST 06', Component: B30},
        TSCRL01: {key: 'B22', key_text: 'XY6', error_id: 'T-SCRL-01', error_id_text: 'XY 11', Component: B22},
        TSCRLXY13: {key: 'B22', key_text: 'XY6', error_id: 'XY-13', error_id_text: 'XY 13', Component: B22},
        XY8_XY15: {key: 'XY8', key_text: 'XY8', error_id: 'XY-15', error_id_text: 'XY 15', Component: XY8},
        SCRS01: {key: 'B31', key_text: 'XY7', error_id: 'SCRS-01', error_id_text: 'XY 12', Component: B31},
        LTSTR01: {key: 'B31', key_text: 'XY7', error_id: 'LTSTR-01', error_id_text: 'LTSTR-01', Component: B31},
        SCRSXY13: {key: 'B31', key_text: 'XY7', error_id: 'XY-13', error_id_text: 'XY 13', Component: B31},
        INF01: {key: 'B40', key_text: 'ST1', error_id: 'INF-01', error_id_text: 'INF 01', Component: B40},
        ST1_ST12: {key: 'B40', key_text: 'ST1', error_id: 'ST 12', error_id_text: 'ST 12', Component: B40},
        LB01: {key: 'G1', error_id: 'LB-01', error_id_text: 'LB 01', Component: G1},
        LB02: {key: 'G1', error_id: 'LB-02', error_id_text: 'LB 02', Component: G1},
        LB03: {key: 'G2', error_id: 'LB-03', error_id_text: 'LB 03', Component: G2},
        LB03IB: {key: 'G2', error_id: 'LB-03 IB', error_id_text: 'LB 03 IB', Component: G2},
        LB04: {key: 'G6', error_id: 'LB-04', error_id_text: 'LB 04', Component: G6},
        LB05: {key: 'G6', error_id: 'LB-05', error_id_text: 'LB 05', Component: G6},
        LB06: {key: 'G6', error_id: 'LB-06', error_id_text: 'LB 06', Component: G6},
        LB07: {key: 'G7', error_id: 'LB-07', error_id_text: 'LB 07', Component: G7},
        LB08: {key: 'G7', error_id: 'LB-08', error_id_text: 'LB 08', Component: G7},
        LB09: {key: 'G6', error_id: 'LB-09', error_id_text: 'LB 09', Component: G6},
        XS4_XS06: {key: 'XS4', error_id: 'XS 06', error_id_text: 'XS 06', Component: XS4},
        XS4_XS08: {key: 'XS4', error_id: 'XS 08', error_id_text: 'XS 08', Component: XS4},
        XS5_XS05: {key: 'XS5', error_id: 'XS 05', error_id_text: 'XS 07', Component: XS5},
        XS5_XS09: {key: 'XS5', error_id: 'XS 09', error_id_text: 'XS 09', Component: XS5},
        OP5_OP05: {key: 'OP5', error_id: 'OP 05', error_id_text: 'OP 05', Component: OP5},
        SV1_SV01: {key: 'SV1', key_text: 'SV1', error_id: 'SV 01', error_id_text: 'SV 01', Component: SV1},
        SV2_SV02: {key: 'SV2', key_text: 'SV2', error_id: 'SV 02', error_id_text: 'SV 02', Component: SV2},
        SV3_SV03: {key: 'SV3', key_text: 'SV3', error_id: 'SV 03', error_id_text: 'SV 03', Component: SV3},
        SV4_SV04: {key: 'SV4', key_text: 'SV4', error_id: 'SV 04', error_id_text: 'SV 04', Component: SV4},
        SV5_SV05: {key: 'SV5', key_text: 'SV5', error_id: 'SV 05', error_id_text: 'SV 05', Component: SV5},
        SV6_SV06: {key: 'SV6', key_text: 'SV6', error_id: 'SV 06', error_id_text: 'SV 06', Component: SV6},
        SV7_SV07: {key: 'SV7', key_text: 'SV7', error_id: 'SV 07', error_id_text: 'SV 07', Component: SV7},
    },
    Compare: {
        NR001: {key: 'C1',key_text: 'C-XS1',  error_id: 'NR-01', error_id_text: 'C-XS 01b', Component: C1},
        NR002: {key: 'C1',key_text: 'C-XS1',  error_id: 'NR-02', error_id_text: 'C-XS 01a', Component: C1},
        NR003: {key: 'C1',key_text: 'C-XS1',  error_id: 'NR-03', error_id_text: 'C-XS 07', Component: C1},
        NRICS001: {key: 'C1',key_text: 'C-XS1',  error_id: 'NR-ICS-01', error_id_text: 'C-XS 01b IB', Component: C1},
        NRICS002: {key: 'C1',key_text: 'C-XS1',  error_id: 'NR-ICS-02', error_id_text: 'C-XS 01a IB', Component: C1},
        CXS1_XS09: {key: 'C1',key_text: 'C-XS1',  error_id: 'C-XS 07', error_id_text: 'C-XS 07', Component: C1},
        SEC001: {key: 'C2',key_text: 'C-XS2',  error_id: 'SEC-01', error_id_text: 'C-XS 02', Component: C2},
        SEC002: {key: 'C2',key_text: 'C-XS2',  error_id: 'SEC-02', error_id_text: 'IS 03', Component: C2},
        SECICS001: {key: 'C2',key_text: 'C-XS2',  error_id: 'SEC-ICS-01', error_id_text: 'C-XS 02 IB', Component: C2},
        NC001: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-01', error_id_text: 'C-ST 01a', Component: C3},
        NC002: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-02', error_id_text: 'C-ST 01b', Component: C3},
        NC003: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-03', error_id_text: 'C-ST 02a', Component: C3},
        NC004: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-04', error_id_text: 'C-ST 02b', Component: C3},
        NC005: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-05', error_id_text: 'C-ST 03a', Component: C3},
        NC006: {key: 'C3',key_text: 'C-ST1',  error_id: 'NC-06', error_id_text: 'C-ST 03b', Component: C3},
        C3_CST07: {key: 'C3',key_text: 'C-ST1',  error_id: 'C-ST 07', error_id_text: 'C-ST 07', Component: C3},
        C3_CST08: {key: 'C3',key_text: 'C-ST1',  error_id: 'C-ST 08', error_id_text: 'C-ST 08', Component: C3},
        TCD001: {key: 'C4',key_text: 'C-ST2',  error_id: 'T-CD-01', error_id_text: 'C-ST 04', Component: C4},
        TCD02: {key: 'C4',key_text: 'C-ST2',  error_id: 'T-CD-02', error_id_text: 'C-ST 05', Component: C4},
        BMC001: {key: 'C5',key_text: 'C-ST3',  error_id: 'BMC-01', error_id_text: 'C-ST 06', Component: C5},
        M006: {key: 'C6',key_text: 'C-RT1',  error_id: 'T-M-01', error_id_text: 'C-RT 01', Component: C6},
        MICS006: {key: 'C6',key_text: 'C-RT1',  error_id: 'T-M-ICS-01', error_id_text: 'C-RT 01 IB', Component: C6},
        ES000: {key: 'C7',key_text: 'C-FW1',  error_id: 'ES-00', error_id_text: 'C-FW 00', Component: C7},
        ES001: {key: 'C7',key_text: 'C-FW1',  error_id: 'T-ES-01', error_id_text: 'C-FW 01', Component: C7},
        TTOPW001: {key: 'C7',key_text: 'C-FW1',  error_id: 'T-TopW-01', error_id_text: 'C-FW 02', Component: C7},
        GRC001: {key: 'C8',key_text: 'C-XY1',  error_id: 'GRC-01', error_id_text: 'C-XY 01', Component: C8},
        RXY001: {key: 'C9',key_text: 'C-XY2',  error_id: 'RXY-01', error_id_text: 'C-XY 02', Component: C9},
        TFLW001: {key: 'C10',key_text: 'C-FL1',  error_id: 'T-FLW-01', error_id_text: 'C-FL 01', Component: C10},
        TFLW002: {key: 'C10',key_text: 'C-FL1',  error_id: 'T-FLW-02', error_id_text: 'C-FL 02', Component: C10},
        FLW003: {key: 'C10',key_text: 'C-FL1',  error_id: 'FLW-03', error_id_text: 'C-FL 03a', Component: C10},
        FLW004: {key: 'C10',key_text: 'C-FL1',  error_id: 'FLW-04', error_id_text: 'C-FL 03b', Component: C10},
        FLW005: {key: 'C10',key_text: 'C-FL1',  error_id: 'FLW-05', error_id_text: 'C-FL 04a', Component: C10},
        FLW006: {key: 'C10',key_text: 'C-FL1',  error_id: 'FLW-06', error_id_text: 'C-FL 04b', Component: C10},
        FLW000: {key: 'C10',key_text: 'C-FL1',  error_id: 'FLW-00', error_id_text: 'C-FL 00', Component: C10},
        WSEL001: {key: 'C11',key_text: 'C-OP1',  error_id: 'T-WSEL-01', error_id_text: 'C-OP 01', Component: C11},
        TWSEL000: {key: 'C11',key_text: 'C-OP1',  error_id: 'T-WSEL-00', error_id_text: 'C-OP 00', Component: C11},
        COP02: {key: 'C-OP2',key_text: 'C-OP2',  error_id: 'C-OP 02', error_id_text: 'C-OP 02', Component: COP2},
        COP03: {key: 'C-OP2',key_text: 'C-OP2',  error_id: 'C-OP 03', error_id_text: 'C-OP 03', Component: COP2},
        WSEL00: {key: 'C11',key_text: 'C-OP1',  error_id: 'WSEL-00', error_id_text: 'WSEL-00', Component: C11},
        WSELICS001: {key: 'C11',key_text: 'C-OP1',  error_id: 'T-WSEL-ICS-01', error_id_text: 'T-WSEL-ICS-01', Component: C11},
        CEC001: {key: 'C12',key_text: 'C-RT2',  error_id: 'T-CECC-01', error_id_text: 'C-RT 01', Component: C12},
        TIEFF001: {key: 'C13',key_text: 'C-XS4',  error_id: 'T-IEFF-01', error_id_text: 'C-IO 01', Component: C13},
        ISSTR01: {key: 'C15',key_text: 'OP5',  error_id: 'IS-STR-01', error_id_text: 'IS-STR-01', Component: C15},
        ISSTR02: {key: 'C15',key_text: 'OP5',  error_id: 'IS-STR-02', error_id_text: 'IS-STR-02', Component: C15},
        C19_SEC01: {key: 'C19',key_text: 'C-XS2',  error_id: 'SEC-01', error_id_text: 'SEC-01', Component: C19},
        TDSRC001: {key: 'C20',key_text: 'C-XS3',  error_id: 'T-DSRC-01', error_id_text: 'C-XS 03', Component: C20},
        DSRC002: {key: 'C20',key_text: 'C-XS3',  error_id: 'DSRC-02', error_id_text: 'T-DSRC-01', Component: C20},
        TOBST001: {key: 'C21',key_text: 'C-XS5',  error_id: 'T-OBST-01', error_id_text: 'C-IO 02', Component: C21},
    }
}